module.exports = __webpack_public_path__ + "static/media/noImageSV.a297042c.jpg";